<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
              <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12 container-navs">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabEnderecos" data-toggle="tab">Endereço</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabOutrosContatos" data-toggle="tab">Outros Contatos</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabClassificacoesClientes" data-toggle="tab">Segmentos Padrões dos Clientes</a>
                </li>                
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabGerentes" data-toggle="tab" *ngIf="isAdministrador">Gerentes</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabAtendentes" data-toggle="tab" *ngIf="isAdministrador">Atendentes</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" data-target="#tabMarcas" data-toggle="tab" *ngIf="isAdministrador && isTipoMercadoMarca()">Marcas</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabLinhas" data-toggle="tab" *ngIf="isAdministrador">Linhas</a>
                </li>   -->
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabRepresentantesVinculados" data-toggle="tab" *ngIf="isAdministrador">Representantes Vinculados</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabConfiguracoes" data-toggle="tab" *ngIf="isAdministrador">Configurações</a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="tabPrincipal">
                    <!-- Pessoa -->
                    <div class="row">
                        <div class="col-12">
                            <sgt-pessoa-form
                                [entity]="entity.pessoa"
                                [parentForm]="form"
                                [canEdit]="false"
                                [dataCadastro]="entity.pessoa?.dataCadastro"
                                [tipoCadastro]="tipoCadastro"
                                [representanteSituacoes]="situacoes"
                                [(representanteSituacao)]="entity.situacao"
                                (validarCnpjCpfCadastrado)="onValidarCnpjCpfCadastrado()"
                                #pessoaForm>
                            </sgt-pessoa-form>
                        </div>
                    </div>
                    <!-- End Pessoa -->
                    <div class="row" *ngIf="isAdministrador">
                        <div class="form-group col-12 col-md">
                            <label for="modalidadeComercial" class="col-form-label">Modalidade Comercial</label>
                            <sgt-representante-modalidade-comercial-select
                                [(ngModel)]="entity.modalidadeComercial"
                                name="modalidadeComercial"
                                id="modalidadeComercial"
                                [required]="true">
                            </sgt-representante-modalidade-comercial-select>
                        </div>
                        <div class="form-group col-12 col-md">
                            <label for="tipoComissao" class="col-form-label">Comissão por</label>
                            <select class="form-control" name="tipoComissao" id="tipoComissao" 
                                [ngModel]="entity.tipoComissao || ''" (ngModelChange)="entity.tipoComissao = $event ? $event : null"
                                #tipoComissao="ngModel" required="required">
                                <option value="">Selecione o tipo da comissão...</option>
                                <option *ngFor="let tipo of tiposComissao" [ngValue]="tipo.id">{{tipo.nome}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="tipoComissao.errors && tipoComissao.errors.required && tipoComissao.dirty"
                                msgError="O tipo da comissão é obrigatório">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md">
                            <label for="percComissao" class="col-form-label">Comissão</label>
                            <div class="input-group">
                                <sgt-decimal [(ngModel)]="entity.percComissao" name="percComissao" id="percComissao"
                                    #percComissao="ngModel" [ngControl]="percComissao" required="required">
                                </sgt-decimal>
                                <div class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                            <sgt-form-control-error
                                *ngIf="percComissao.errors && percComissao.errors.required && percComissao.dirty"
                                msgError="A comissão é obrigatória">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="percComissao.errors && percComissao.errors.decimalInvalid"
                                msgError="Comissão inválida">
                            </sgt-form-control-error>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="anotacao" class="col-form-label">Anotação</label>
                            <textarea class="form-control" [(ngModel)]="entity.anotacao" name="anotacao" id="anotacao"
                                #anotacao="ngModel" rows="8">
                            </textarea>
                        </div>
                    </div>
                </div>

                <!-- Endereços -->
                <div class="tab-pane" id="tabEnderecos">
                    <sgt-pessoa-endereco-unico
                        [tipoEndereco]="enderecoPrincipal"
                        [(entity)]="entity.pessoa.enderecoPrincipal"
                        #pessoaEnderecoPrincipal
                        [canEdit]="false"
                        [permiteExcluir]="false"
                        [tipoContato]="contatoPrincipal"
                        [exterior]="entity.pessoa.exterior"
                        [cepRequired]="!entity.pessoa.exterior"
                        [bairroRequired]="!entity.pessoa.exterior"
                        [(entityContato)]="entity.pessoa.contatoPrincipal">
                    </sgt-pessoa-endereco-unico>
                </div>
                <!-- End Endereços -->

                <!-- Outros Contatos -->
                <div class="tab-pane" id="tabOutrosContatos">
                    <sgt-pessoa-contato
                        idTable="tablePessoaContatosRepresentanteForm"
                        [idPessoa]="entity.pessoa.id"
                        [entities]="entity.pessoa.outrosContatos"
                        #pessoaOutrosContatosCadastro>
                    </sgt-pessoa-contato>
                </div>
                <!-- End Outros Contatos -->

                <!-- Classificações de Clientes -->
                <div class="tab-pane" id="tabClassificacoesClientes">
                    <div class="alert alert-info" role="alert">
                        <i class="fas fa-info" aria-hidden="true"></i> Adicione os segmentos padrões dos clientes que este representante atende para que os mesmos já sejam configurados quando forem cadastrados novos clientes.
                    </div>
                    
                    <sgt-representante-classificacao-cliente-form
                        #classificacaoClienteForm
                        [idRepresentante]="entity.id"
                        [(entities)]="entity.classificacoesClientes">
                    </sgt-representante-classificacao-cliente-form>
                </div>                

                <!-- Gerentes -->
                <div class="tab-pane" id="tabGerentes" *ngIf="isAdministrador">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <p class="mb-0"><i class="fas fa-info" aria-hidden="true"></i> Adicione os gerentes para que os mesmos tenham acesso as informações deste representante, tais como, clientes, pedidos, títulos, etc.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="usuarioGerente" class="col-form-label">Principal</label>
                            <sgt-typeahead-usuario [(ngModel)]="entity.usuarioGerente"  name="usuarioGerente" id="usuarioGerente"
                                #usuarioGerente="ngModel" [ngControl]="usuarioGerente" [perfil]="3" [ativos]="true"
                                (typeaheadChange)="onTypeaheadChangeUsuarioGerente($event)">
                            </sgt-typeahead-usuario>
                            <p class="form-text text-muted">
                                Gerente principal deste representante
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-representante-gerente
                                #gerenteCadastro
                                [entities]="entity.gerentes">
                            </sgt-representante-gerente>
                            <p class="form-text text-muted">
                                Outros gerentes que podem ter acesso a este representante
                            </p>
                        </div>
                    </div>
                </div>
                <!-- End Gerentes -->

                <!-- Atendentes -->
                <div class="tab-pane" id="tabAtendentes" *ngIf="isAdministrador">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <p class="mb-0"><i class="fas fa-info" aria-hidden="true"></i> Adicione os atendentes para que os mesmos tenham acesso as informações deste representante, tais como, clientes, pedidos, títulos, etc.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="usuarioGerente" class="col-form-label">Principal</label>
                            <sgt-typeahead-usuario [(ngModel)]="entity.usuarioAtendente"  name="usuarioAtendente" id="usuarioAtendente"
                                #usuarioAtendente="ngModel" [ngControl]="usuarioAtendente" [perfil]="4" [ativos]="true"
                                (typeaheadChange)="onTypeaheadChangeUsuarioAtendente($event)">
                            </sgt-typeahead-usuario>
                            <p class="form-text text-muted">
                                Atendente principal deste representante
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-representante-atendente
                                #atendenteCadastro
                                [entities]="entity.atendentes">
                            </sgt-representante-atendente>
                            <p class="form-text text-muted">
                                Outros atendentes que podem ter acesso a este representante
                            </p>
                        </div>
                    </div>
                </div>
                <!-- End Atendentes -->

                <!-- Marcas -->
                <!-- <div class="tab-pane" id="tabMarcas" *ngIf="isAdministrador && isTipoMercadoMarca()">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <p><i class="fas fa-info" aria-hidden="true"></i> Adicione as marcas que este representante deve ter acesso e visibilidade.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-representante-marca
                                [entities]="entity.marcas"
                                #marcaCadastro>
                            </sgt-representante-marca>
                        </div>
                    </div>
                </div> -->
                <!-- End Marcas -->

                <!-- Linhas -->
                <!-- <div class="tab-pane" id="tabLinhas" *ngIf="isAdministrador">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                <p><i class="fas fa-info" aria-hidden="true"></i> Adicione as linhas que este representante deve ter acesso e visibilidade.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-representante-linha
                                [entities]="entity.linhas"
                                #linhaCadastro>
                            </sgt-representante-linha>
                        </div>
                    </div>
                </div> -->
                <!-- End Linhas -->

                <!-- Representante Vinculados -->
                <div class="tab-pane" id="tabRepresentantesVinculados" *ngIf="isAdministrador">
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info" role="alert">
                                    <i class="fas fa-info" aria-hidden="true"></i> Vincule outros representantes para que este representante possa:
                                <ul class="mb-0">
                                    <li>Consultar pedidos do(s) representante(s) vinculado(s) - Útil para consultar o histório dos pedidos de representantes anteriores que foram desligados;</li>
                                    <li>Consultar títulos do(s) representante(s) vinculado(s) - Útil para consultar o histório dos títulos e títulos vencidos de representantes anteriores que foram desligados;</li>
                                    <li>Histório da evolução da carteira de clientes e de clientes atendidos;</li>
                                    <li>Consultas de vendas, tais como: Efetividade de Venda, Curva ABC de Vendas, Média de Pedido, Média de Compra, etc.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <sgt-representante-vinculado
                                [entities]="entity.representantesVinculados"
                                #representanteVinculadoCadastro>
                            </sgt-representante-vinculado>
                        </div>
                    </div>
                </div>
                <!-- End Representante Vinculados -->

                <!-- Configurações -->
                <div class="tab-pane" id="tabConfiguracoes" *ngIf="isAdministrador">
                    <sgt-representante-configuracao
                        [entity]="entity">
                    </sgt-representante-configuracao>
                </div>
                <!-- End Configurações -->
            </div>
        </div>
    </div>
</form>
